export default __webpack_public_path__ + "static/media/home-about-planet.a4ab7775.jpg";